import React from 'react';
import { StyledSeparator, StyledAlbumTwistyContainer, StyledAlbumTwistyText, StyledAlbumTwistySelectionButtonContainer, StyledSelectionButton, StyledAlbumTwistySubHeaderText } from './Style';
export const AlbumTwisty = ({ headerText, fontSize, isSelectModeOn = false, onSelectAll, onDeselectAll, translateFn = (key) => key, subHeaderText, areAllTilesSelected, areAnyTilesSelected }) => {
    const handleSelectAllClick = (event) => {
        event.stopPropagation();
        onSelectAll();
    };
    const handleDeselectAllClick = (event) => {
        event.stopPropagation();
        onDeselectAll();
    };
    const subHeaderElement = subHeaderText ? (React.createElement(StyledAlbumTwistySubHeaderText, { fontSize: fontSize }, subHeaderText)) : null;
    return (React.createElement(StyledAlbumTwistyContainer, null,
        React.createElement("div", null,
            React.createElement(StyledAlbumTwistyText, { fontSize: fontSize }, headerText),
            subHeaderElement),
        isSelectModeOn && (React.createElement(StyledAlbumTwistySelectionButtonContainer, { onClick: e => e.stopPropagation() },
            React.createElement(StyledSelectionButton, { onClick: handleSelectAllClick, type: 'button', disabled: areAllTilesSelected }, translateFn('Select All')),
            React.createElement(StyledSeparator, null),
            React.createElement(StyledSelectionButton, { onClick: handleDeselectAllClick, type: 'button', disabled: !areAnyTilesSelected }, translateFn('Clear All'))))));
};
//# sourceMappingURL=AlbumTwisty.js.map